import React from 'react';

import WrappedRoutes from './wrapped-routes';
import DataDependencies from './data-dependencies';

export default <WrappedRoutes dataDependencies={DataDependencies} />;
